import { all } from 'redux-saga/effects';

import manageTeamSaga from './manage-team-saga';

export default function* rootSaga(action) {
	yield all([manageTeamSaga(action)]);
}
